import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { chatPipSize, selectedWidget, workareaSize } from 'src/core/types/workarea.types';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {

  $selectedWidget: BehaviorSubject<selectedWidget> = new BehaviorSubject<selectedWidget>("bookmark");
  $workareaSize: BehaviorSubject<workareaSize> = new BehaviorSubject<workareaSize>("medium");
  $activeTab: BehaviorSubject<string> = new BehaviorSubject<string>("");
  $chatPipSize: BehaviorSubject<chatPipSize> = new BehaviorSubject<chatPipSize>("minimized");

  constructor() { }

  expandWidget(widget: selectedWidget, filter: string) {
    this.$selectedWidget.next(widget);
    if(widget === "bookmark" && this.$workareaSize.value !== "fullscreen") {
      this.$workareaSize.next("medium");
      return;
    }
    if(this.$workareaSize.value !== "fullscreen") {
      this.$workareaSize.next("large");
    }
    
    if (filter) {
      this.$activeTab.next(filter);
    }
  }

  closeWidget() {
    this.$workareaSize.next("small");
    this.$selectedWidget.next("None");
    this.$activeTab.next("");
  }

  onMaximize() {
    if (this.$workareaSize.value === "large") {
      this.$workareaSize.next("medium");
    }
    else {
      this.$workareaSize.next("large");
    }
  }

  resetWidgets() {
    this.$selectedWidget.next("None");
    this.$workareaSize.next("small");
    this.$activeTab.next("");
  }

  onMinimize() {
    this.$workareaSize.next("small");
  }

  onExpand() {
    this.$workareaSize.next("fullscreen");
  }
  switchTab(tab: string) {
    this.$activeTab.next(tab);
  }
}